export default {
  all: "All",
  nearMe: "Near Me",
  new: "New",
  welcomeAabcusOnlineOrdering: "Welcome to Aabcus online ordering",
  away: "Away",
  open: "Open",
  restaurants: "Restaurants",
  pageNotFound: "Page Not Found",
  menu: "Menu",
  orderOnline: "Order Online",
  gettingYourGiftcard: "Getting your giftcard",
  checkout: "Checkout",
  payNow: "Pay Now",
  fromName: "From",
  toName: "To",
  giftEmail: "Recipient Email",
  email: "Email",
  message: "Message",
  cancel: "Cancel",
  addToCart: "Add to Cart",
  maximumQuantityExceeded: "Maximum Quantity Exceeded",
  giftCards: "Gift Cards",
  remove: "Remove",
  subtotal: "Subtotal",
  total: "Total",
  delivery: "Delivery",
  addCouponOrGiftCardNumber: "Add Coupon or Gift Card number",
  apply: "Apply",
  yourOrder: "Your Order",
  placeOrder: "Place Order",
  minimumPurchaseIs: "Minimum purchase is",
  continueOrdering: "Continue Ordering",
  cardType: "Card Type",
  masterCard: "Master Card",
  visaCard: "Visa Card",
  cardHolderName: "Card Holder Name",
  cardNumber: "Card Number",
  expiryDate: "Expiry Date",
  CVV: "CVV",
  myAccount: "My Account",
  loyalty: "Loyalty",
  orderHistory: "Order History",
  orderTracking: "Order Tracking",
  logOut: "Log Out",
  login: "Login",
  register: "Register",
  aboutUs: "About Us",
  contactUs: "Contact Us",
  privacyPolicy: "Privacy Policy",
  somethingIsWrong: "Something is wrong",
  logViewer: "log viewer",
  clearLog: "clear log",
  no: "NO",
  category: "Category",
  type: "Type",
  description: "Description",
  path: "path",
  dateTime: "Date/Time",
  more: "More",
  close: "close",
  poweredBy: "Powered By",
  ok: "OK",
  deliveryPolicy: "Delivery Policy",
  termsAndConditions: "Terms And Conditions",
  refundPolicy: "Refund Policy",
  stores: "STORES",
  logIn: "Log in",
  address: "Address",
  streetAddress: "Street Address",
  postcode: "Postcode",
  deliveryNotAvailableFor: "Delivery not available for",
  suburb: "Suburb",
  state: "State",
  deliveryInstructions: "Delivery Instructions",
  tableNumber: "Table Number",
  firstName: "First Name",
  lastName: "Last Name",
  emailAddress: "Email address",
  registerNewAccount: "Register a new account",
  placingOrderAsGuest:
    "Left unchanged you will be placing your order as a guest",
  alreadyAccountForEmail: "We already have an account for this email, you can",
  yourDetails: "Your Details",
  phoneNumber: "Phone Number",
  payment: "Payment",
  cardInfo: "Card Info",
  saveCardForNextTime: "Save card for next time",
  pickUp: "Pick up",
  pickUpFrom: "Pick up from",
  roomDetails: "Room Details",
  roomNumber: "Room Number",
  placeAnOrderAsGuestWithoutCreatingAccount:
    "or you may also place an order as a guest without creating an account",
  gettingYourMeal: "Getting your meal",
  deliverToRoom: "Deliver to room",
  dineIn: "Dine in",
  deliveryDate: "Delivery Date",
  pickupDate: "Pickup Date",
  deliveryTime: "Delivery Time",
  pickupTime: "Pickup Time",
  chargeToRoomGuestsWithAuthorisedCreditCardsOnly:
    "Charge to room (Guests With Authorised Credit Cards only.)",
  payByLoyaltyPoints: "Pay by Loyalty Points",
  payByCash: "Pay by Cash",
  payByAlipay: " Pay by Alipay",
  payByWechat: " Pay by Wechat",
  notes: "Notes",
  payByCard: "Pay by card",
  becomeMember: "Become a member",
  skip: "Skip",
  fasterCheckoutManageOrdersEarnPoints:
    "Faster checkout, manage your orders, earn points and much more",
  emailConfirmation:
    "Registration instruction has been emailed to you, please follow the instruction on the email to finalise your registration",
  viewMyOrderHistory: "View my order history",
  orderSubmitted: "Order Submitted",
  beingPrepared: "Being Prepared",
  ready: "Ready",
  yourOrderHasBeenRejected: "Your order has been rejected",
  yourSavedOrder: "Your saved order",
  thankYou: "Thank you",
  closedToday: "Closed Today",
  viewCart: "View Cart",
  customize: "Customize",
  forgotPassword: "Forgot Password",
  passwordRecoveryLinkIsNoLongerValid:
    "Password recovery link is no longer valid",
  confirmPassword: "Confirm Password",
  store: "Store",
  couponDoesNotApplyToAnyItems: "Coupon does not apply to any items",
  accessToCameraHasBeenBlocked: "Access to camera has been blocked",
  order: "Order",
  clearAll: "Clear all",
  gst: "GST",
  discount: "Discount",
  surcharge: "Surcharge",
  redeemStamps: "Redeem Stamps",
  totalIncGST: "Total (Inc GST)",
  promotions: "Promotions",
  facebook: "Facebook",
  google: "Google",
  myCards: "My Cards",
  addACard: "Add a card",
  addCard: "Add card",
  storeCard: "Store card",
  areYouSureDeleteCard: "Are you sure you want to delete this card?",
  signInToYourAccount: "Sign in to your account",
  termsOfUsePrivacyStatement:
    "By continuing you agree to our <b>Terms of Use & Privacy Statement</b>",
  signIn: "Sign In",
  sendLink: "Send Link",
  haventGotAnAccount: "Haven't got an account",
  orSignInWith: "Or sign in with",
  password: "Password",
  loyaltyPts: "LOYALTY PTS",
  ptsEarned: "PTS EARNED",
  ptsSpent: "PTS SPENT",
  orderPlacedSuccessfully: "Order placed successfully",
  orderNo: "Order No",
  reorder: "Reorder",
  view: "View",
  reorderCurrentOrder: "Are you sure you want to reorder current order",
  profileSavedSuccessfully: "Profile Saved Successfully",
  saveChanges: "Save Changes",
  createYourAccount: "Create your Account",
  alreadyHaveProfile: "Already have a profile",
  stamps: "stamps",
  loyaltyStamps: "LOYALTY STAMPS",
  holidaySurcharge: "Holiday Surcharge",
  bankSurcharge: "Bank Surcharge",
  back: "Back",
  next: "Next",
  confirm: "Confirm",
  apiTimeoutMessage: `We are sorry, network error encountered during payment. Please check your credit card account if the funds have been charged.
  Please contact {msg} for further technical support.`,
  reorderOtherStoreMessage: "Please go to {0} store for reorder this item!"
};
